"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.humanReadableScore = humanReadableScore;
exports.getResults = getResults;
exports.getScales = getScales;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.PSS4;
var pssOptions = ["Never", "Almost Never", "Sometimes", "Fairly Often", "Very Often"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "dot",
  extraText: "In the last week, how often have you",
  options: pssOptions
};
var pssQuestions = [// PSS - 4 questions
{
  prompt: "Felt that you were unable to control the important things in your life?"
}, {
  prompt: "Felt confident about your ability to handle your personal problems?",
  options: pssOptions,
  reversed: true
}, {
  prompt: "Felt that things were going your way?",
  options: pssOptions,
  reversed: true
}, {
  prompt: "Felt difficulties were piling up so high that you could not overcome them?"
}];

function humanReadableScore(pssScore) {
  var summaryString = "Much Lower than Average";

  if (pssScore > 30) {
    summaryString = "Slightly Lower than Average";
  }

  if (pssScore > 42) {
    summaryString = "Average";
  }

  if (pssScore > 57) {
    summaryString = "Slightly Higher than Average";
  }

  if (pssScore > 70) {
    summaryString = "Much Higher than Average";
  }

  return summaryString;
}

var questions = (0, _utils.wrapBattery)(pssQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var score = Math.round((0, _sum2["default"])(answers) * 6.25);
  var humanReadable = {
    PSS: "".concat(score, " (").concat(humanReadableScore(score), ")")
  };
  return {
    PSS: score,
    PSS_1: answers[0],
    PSS_2: answers[1],
    PSS_3: answers[2],
    PSS_4: answers[3],
    humanReadable: humanReadable
  };
}

function getScales() {
  var scales = {
    PSS: "Much Lower than Average (0-30), Slightly Lower than Average (31-42), Average (43-57), Slightly Higher than Average (58-70), Much Higher than Average (71-100)"
  };
  return scales;
}